export default __webpack_public_path__ + "static/VodafoneThreeLogo-a7cad762e5a0f867577a34ea56d802b6.webp";